<template>
  <v-row class="mb-3 mr-sm-0">
<!--    <v-col class="styles">{{ text }}</v-col>-->
      <v-col class="styles">SURGEON GENERAL'S WARNING: Smoking Causes Lung Cancer, Heart Disease, Emphysema, And May Complicate Pregnancy.</v-col>
  </v-row>
</template>

<script>
export default {
  name: "SurgeonGeneralsWarning",
  props: {
    text: String,
  },
};
</script>

<style scoped>
.styles {
  align-items: center;
  background-color: white;
  border: black solid 8px;
  height: 20vh; /* optimal height of surgeon general warning */
  display: flex;
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-semibold);
  justify-content: center;
  margin: 0 12px;
  max-height: 264px; /* restrains the height of longest surgeon general warning with maximum window height */
  min-height: 204px; /* restrains the height of longest surgeon general warning with minimal window height */
  padding: 0 12px;
  text-align: center;
}
@media (min-width: 668px) {
  .styles {
    font-size: var(--font-size-xl);
    margin: 0;
  }
}
</style>
